import React from "react";
import NavBar from "components/NavBar/NavBar";
import "aos/dist/aos.css";
import "./Home.css";
import SideBar from "components/NavBar/SideBar";
import Home from "components/Home/Home";
import About from "components/About/About";
import Skills from "components/Skills/Skills";
import Projects from "components/Projects/Projects";
// import Blog from "components/Blogs/Blogs";
import Contact from "components/Contact/Contact";
import Footer from "components/Footer/Footer";

const Landing = () => {
  return (
    <>
      <div className="body">
        <div className="navbar">
          {" "}
          <NavBar />{" "}
        </div>
        <Home />
        <About />
        <Skills />
        <Projects />
        {/* <Blog /> */}
        <Contact />
        <Footer />
        <div className="navbar_1">
          <SideBar />
        </div>
      </div>
    </>
  );
};

export default Landing;
